import { IAppState } from '../../redux';
import { selectBetPosition } from './selectBetPosition';

export function selectBetServiceConcurrency(state: IAppState): number | null {
  const betPosition = selectBetPosition(state);

  if (!betPosition) {
    return null;
  }

  return betPosition.betServiceConcurrency;
}
